import BlogSubscribeBoxForm from "./BlogSubscribeBoxForm";
import type { BlogSubscribeBoxFormProps } from "./BlogSubscribeBoxForm.d";

export default BlogSubscribeBoxForm;
export type { BlogSubscribeBoxFormProps };
